import {
  OfficeBuilding, User, Location, Folder,
  Setting, View, Edit, Document,
  Upload, Switch, School, DataAnalysis,
  Tickets, Grid, Star, DataBoard,
  FolderOpened, Files, Operation, Management,
  Menu, Collection, TrendCharts,
} from '@element-plus/icons-vue'

// Простое сопоставление view названий с иконками
const iconMappings: Record<string, any> = {
  // Организации
  'organization': OfficeBuilding,
  'school': School,
  'preschool': School,
  
  // Пользователи
  'user': User,
  'personnel': User,
  'staff': User,
  'role': User,
  
  // Заявки и документы
  'application': Tickets,
  'voucher': Tickets,
  'request': Switch,
  'enrollment': Tickets,
  
  // Адреса
  'address': Location,
  'location': Location,
  'territory': Location,
  
  // Каталоги
  'catalog': Folder,
  'directory': Folder,
  'dictionary': Folder,
  'folder': Folder,
  'folderopened': FolderOpened,
  'files': Files,
  'collection': Collection,
  
  // Система
  'view': View,
  'editor': Edit,
  'entities': Edit,
  'attribute': Edit,
  'rule': Setting,
  'validation': Setting,
  
  // Задачи
  'task': Document,
  'process': Document,
  'work': Document,
  'contingent': Document,
  'group': Document,
  
  // Файлы
  'file': Upload,
  'upload': Upload,
  'document': Document,
  
  // Аналитика
  'aggregation': DataAnalysis,
  'statistic': DataAnalysis,
  'analytic': DataAnalysis,
  'data': DataBoard,
  'chart': TrendCharts,
  
  // Общие
  'menu': Grid,
  'new': Star,
  'operation': Operation,
  'management': Management,
  'admin': Management,
}

/**
 * Получает подходящую иконку для viewName
 * @param viewName - название view
 * @returns компонент иконки Element Plus
 */
export function getViewIcon(viewName: string): any {
  if (!viewName) return Document

  const normalizedViewName = viewName.toLowerCase()
  
  // Ищем прямое совпадение
  for (const [keyword, icon] of Object.entries(iconMappings)) {
    if (normalizedViewName.includes(keyword)) {
      return icon
    }
  }

  return Document
}

/**
 * Получает иконку с кешированием для оптимизации
 */
const iconCache = new Map<string, any>()

export function getCachedViewIcon(viewName: string): any {
  if (iconCache.has(viewName)) {
    return iconCache.get(viewName)
  }
  
  const icon = getViewIcon(viewName)
  iconCache.set(viewName, icon)
  return icon
}
